/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Exception': {
    width: 11,
    height: 11,
    viewBox: '0 0 11 11',
    data: '<g _fill="#FF5440" fill-rule="evenodd"><path pid="0" d="M5.266 10.699a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-.91a4.09 4.09 0 1 0 0-8.18 4.09 4.09 0 0 0 0 8.18z" fill-rule="nonzero"/><path pid="1" d="M5.594 6.595h-.655l-.137-3.331h.921l-.13 3.33zm-.331 1.54a.502.502 0 0 1-.497-.497c0-.274.223-.504.497-.504a.51.51 0 0 1 .503.504c0 .266-.23.496-.503.496z"/></g>'
  }
})
